/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import { Button } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

class SheetDownload extends React.Component {
  fileReader = new FileReader()
  fileInputRef = React.createRef()
  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
  }

  onDownloadClick = async () => {
    const { orders } = this.props
    const sortedOrders = _.sortBy(orders, 'created_at')
    const csvString = await this.generateCSV(sortedOrders)

    const snapshot = await this.uploadFile(csvString)
    this.downloadFile(snapshot)
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  generateCSV = async orders => {
    const { headers, extraFields = [] } = this.props

    let csvString = ''

    csvString = csvString.concat(`${headers.join(', ')} \n`)
    csvString = csvString.concat(`${orders.join('\n')} \n`)
    csvString = csvString.concat(`${extraFields.join('\n')} \n`)

    return csvString
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const ordersFromJson = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(ordersFromJson)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile = async csvString => {
    const { filename } = this.props
    const storage = firebase
      .storage()
      .ref()
      .child(`report/${filename}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloading, downloadUrl } = this.state
    const { orders, loading } = this.props

    return (
      <div style={{ display: 'inline' }}>
        <Button
          disabled={downloading || loading || _.size(orders) === 0}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download Report
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".csv"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

export default SheetDownload



// WEBPACK FOOTER //
// ./src/containers/reports/components/DownloadSheetButton.js